import { Helmet } from "react-helmet-async";

const REFERENCE_HOST = "https://mist-cms-beta.preview.emergentagent.com";

/**
 * Rewrites the canonical URL host if it still points to the reference/scraper
 * domain (mist-cms-beta.preview.emergentagent.com). We keep the original
 * host if the CMS admin has explicitly set a different one.
 */
function normaliseCanonical(canonical) {
  if (!canonical) return canonical;
  if (canonical.startsWith(REFERENCE_HOST) && typeof window !== "undefined") {
    return canonical.replace(REFERENCE_HOST, window.location.origin);
  }
  return canonical;
}

export default function SEO({ seo, fallbackTitle }) {
  const title = (seo && seo.title) || fallbackTitle || "MIST Quality Inspection and Logistics";
  const description =
    (seo && seo.description) ||
    "Independent inspection, quality assurance, conformity support and integrated logistics services across Somalia and East Africa.";
  const canonical = normaliseCanonical(seo && seo.canonical);
  const ogTitle = (seo && seo.og_title) || title;
  const ogDescription = (seo && seo.og_description) || description;
  const ogImage = seo && seo.og_image;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}
